/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProfileData { 
    name?: string | null;
    loginName?: string | null;
    email?: string | null;
    firstSurname?: string | null;
    secondSurname?: string | null;
}

